import { Pipe, PipeTransform } from '@angular/core';
import { Match } from '../match.model';
import { IsPreMatchOnlyPipe } from './is-pre-match-only.pipe';

/**
 * A pipe which transforms a [`Match`](../match.model.ts)
 * object into a boolean, representing whether the match is ongoing, and the match's
 * sport is supported for live updates on this client (verified by using the [`IsPreMatchOnlyPipe`](./is-pre-match-only.pipe.ts)).
 */
@Pipe({
  name: 'isLive',
  pure: false,
})
export class IsLivePipe implements PipeTransform {

  constructor(
    private isPreMatchOnlyPipe: IsPreMatchOnlyPipe
  ) { }

  /**
	 * A pipe which transforms a [`Match`](../match.model.ts)
	 * object into a boolean, representing whether the match is ongoing, and the match's
   * sport is supported for live updates on this client (verified by using the [`IsPreMatchOnlyPipe`](./is-pre-match-only.pipe.ts)).
	 * @param match the `Match` object for the sporting match
	 * @returns `true` if the match's live data indicates that the match is in progress, and the `IsPreMatchOnlyPipe` transforms `match` into
   * `false`; `false` if either of those conditions is not met.
	 */
  transform(match: Match): boolean {
    /** Match statuses which indicate that a match is in progress are `live`, `inprogress` and `halftime` */
    return match && match.LiveData
			&& (match.LiveData.status === "live" || match.LiveData.status === "inprogress" || match.LiveData.status === "halftime")
			&& !this.isPreMatchOnlyPipe.transform(match);
  }

}
